import qs from 'qs'
import config from '../../config'
import { buildGetQuery } from '../../util'
import { QueryObserverOptions } from '@tanstack/react-query'

import { ITrainingCategory, IGetRequestObject } from '../../interfaces'

type QueryObject = {
  activeOnly?: boolean
}

const getTrainingCategoriesDetailsRequest = (
  params: undefined,
  queryObject: QueryObject | undefined,
): IGetRequestObject => {
  const queryString = qs.stringify(queryObject, { addQueryPrefix: true })
  return {
    method: 'get',
    url: `${config.baseUrl}/TrainingCategories${queryString}`,
  }
}

const useTrainingCategoriesDetailsQueryBase = buildGetQuery<
  undefined,
  QueryObject | undefined,
  ITrainingCategory[] | undefined
>({
  getRequest: getTrainingCategoriesDetailsRequest,
  getQueryKey: (params, queryObject) => [
    'training-categories-details',
    queryObject?.activeOnly,
  ],
})

const useTrainingCategoriesDetailsQuery = (
  queryObject?: QueryObject,
  options?: QueryObserverOptions<ITrainingCategory[] | undefined, Error>,
) => {
  const trainingCategoriesDetailsQuery = useTrainingCategoriesDetailsQueryBase(
    undefined,
    queryObject,
    options,
  )
  return { ...trainingCategoriesDetailsQuery }
}

export default useTrainingCategoriesDetailsQuery
